import React, { Component } from 'react';
import { Card,Button, Icon } from 'semantic-ui-react'
import {GetData} from './../../api/Service';

class EventList extends Component {
    constructor(Props) {
        super(Props);
        this.state = {
            news: [],
            news_det: []
        }
    }

    componentDidMount() {
        var url = "http://192.168.43.104:5000/api/events/1/20";
        /* fetch(url).then(resp => resp.json())
            .then(json => {
                //console.log(json);
                this.setState({
                    news: json.rows,
                    news_det: json.b_arr
                })
            }); */

        GetData('api/events/1/20')
            .then(json => {
                //console.log(json);
                this.setState({
                    news: json.rows.map(el => {
                        return {
                            ...el,
                            description: JSON.parse(el.description),
                            //uploadInfo: JSON.parse(el.uploadInfo)
                        }
                    }),
                    news_det: json.b_arr
                })
            });
    }

    editClick(value){
        this.props.onEditClick(value);
    }

    onDeleteClick(id){
        this.props.onDeleteClick(id);
    }
    render() {
        let arr = [];
        let n = this.state.news;
        n.map((nn,index) =>
            arr.push(<div key={index} className="notice-list-item">
                <h3>
                    {nn.title}
                        </h3>
                <b>on {nn._date_}</b>
                <p>
                    {nn.description[0].description}
                    </p>
                <div>Venue: {nn.description[0].venue}</div>
                <div>Time: { nn.description[0].time }</div>
                <div>
              <Button primary type="button" onClick={this.editClick.bind(this,nn)}>Edit</Button>     &nbsp;          
              <Button color='red' type="button" onClick={this.onDeleteClick.bind(this,nn.id)}>Delete</Button>              
            </div>
            </div>)
        )
        return (
            <div className="notice-list">
                
                {arr}
    

            </div>
        )
    }
}


export default EventList;


// WEBPACK FOOTER //
// ./src/HomeComponents/Events/EventList.js